<template>
	<div class="field">
		<slot />
		<vue-editor
			v-model="texte"
			:editor-options="editorSettings"
			:placeholder="placeholder"
			:label="label"
			:class="row ? 'row'+row : ''"
			@input="onInput"
			@blur="onBlur"
			@focus="onFocus" />
		<div v-if="$slots.suffix" class="suffix">
			<slot name="suffix" />
		</div>
	</div>
</template>
<style lang="scss" scoped>
	@import '../../../src/assets/less/variables.scss';

	.field{
		line-height:1em!important;
		height: inherit!important;
		position: relative;


		.suffix{
			padding-top: 5px;
		}

	}
	.btn-toolbar{
		position: absolute;
		top:5px;
		right: 5px;
		z-index: 1;
	}
	/deep/ .quillWrapper {
		position: relative;
		width: 100%;

		.ql-toolbar.ql-snow{
			z-index: 1;
			padding:inherit;
			position: absolute;
			right: 0;
			/*font: 400 16px Roboto,RobotoDraft,Helvetica,Arial,sans-serif;*/
			border: none;

			span.ql-formats {
				margin: 0;
				& + .ql-formats {
					margin-left: 15px;
				}
			}
		}
		&.hide-toolbar .ql-toolbar{
			display: none!important;
		}
		.ql-editor.ql-blank::before{
			font-style: inherit;
			display: inherit;
			color:#adadad;
			@extend .ellipsis;
			left: 10px;
			right: 10px;
		}

		.ql-editor {
			padding: 9px 10px;
			min-height: 40px;
		}
		&.row2 .ql-editor{ min-height: 62px;/*22*2+9*2*/ }
		&.row3 .ql-editor{ min-height: 84px; }
		&.row4 .ql-editor{ min-height: 106px; }
		&.row5 .ql-editor{ min-height: 128px; }

		.ql-container.ql-snow{
			border: none;
		}
		.ql-toolbar + .ql-container{
			.ql-editor {
				/*padding-top: 40px;*/
			}
		}
	}

</style>
<script>
	import { VueEditor } from "vue2-editor";

	export default {
		name:'VueInputTextarea',
		components: {
			VueEditor,
		},
		props: {
			value: { default:''},
			toolbar: {default: true},
			label: {default: null},
			placeholder: {default: null},
			row: {default: null},
		},
		data() {
			return {
				inputFocused: false,
				texte: this.value,
				toolbarVisible: false,
				editorSettings:{
					"modules": {
						"toolbar":
							this.toolbar ? [
								['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block', 'code'],        // toggled buttons
								[{ 'list': 'ordered'}, { 'list': 'bullet' }],
								[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
								[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
								// [{ 'align': [] }],
								[],
								['clean']
							] : []
					}
				}
			}
		},
		watch:{
			value:function(value){
				this.texte = value;
			}
		},
		methods: {
			switchToolbarVisibility(){
				this.toolbarVisible =! this.toolbarVisible;
			},
			onBlur(e){
				this.inputFocused = false;
				this.toolbarVisible = this.toolbar;
				this.$emit('blur', e);
			},
			onFocus(e){
				this.inputFocused = true;
				this.$emit('focus', e);
			},
			onInput(e){
				this.$emit('input', e);
			}
		},
	}
</script>

